'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @date 2015/12/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ISOComponent = require('./ISOComponent');

var _ISOComponent2 = _interopRequireDefault(_ISOComponent);

var _ISOMsg = require('./ISOMsg');

var _ISOMsg2 = _interopRequireDefault(_ISOMsg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ISOPackager = function () {
  function ISOPackager() {
    _classCallCheck(this, ISOPackager);
  }

  _createClass(ISOPackager, [{
    key: 'pack',


    /**
     * @param   m   the Component to pack
     * @return Array     Message image
     */
    value: function pack(m) {}

    /**
     * @param   m   the Container of this message
     * @param   b   ISO message image
     * @return Number     consumed bytes
     */

  }, {
    key: 'unpack',
    value: function unpack(m, b) {}

    /**
     * @return String  Packager's Description
     */

  }, {
    key: 'getDescription',
    value: function getDescription() {}

    /**
     * @param   m   the Container (i.e. an ISOMsg)
     * @param   fldNumber the Field Number
     * @return  String Field Description
     */

  }, {
    key: 'getFieldDescription',
    value: function getFieldDescription(m, fldNumber) {}

    /**
     * @return ISOMsg as ISOMsg;
     */

  }, {
    key: 'createISOMsg',
    value: function createISOMsg() {}
  }]);

  return ISOPackager;
}();

exports.default = ISOPackager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/ISOPackager.js
// module id = 25
// module chunks = 0